import { theme } from "@skin/v2";

import { Icons } from "../components/icon/icon";
import { AgencyNoticeType } from "./enums";

export const colorsByAgencyNoticeType: Record<
  AgencyNoticeType,
  {
    background: string;
    color: string;
  }
> = {
  [AgencyNoticeType.CRITICAL]: {
    background: "#ffe2e5",
    color: theme.colors.pink[700],
  },
  [AgencyNoticeType.INFO]: {
    background: theme.colors.white,
    color: theme.colors.blue[700],
  },
  [AgencyNoticeType.SUCCESS]: {
    background: theme.colors.white,
    color: theme.colors.green[500],
  },
  [AgencyNoticeType.WARNING]: {
    background: "#fff3e7",
    color: "#e14e00",
  },
};

export const iconsByAgencyNoticeType: Record<AgencyNoticeType, Icons> = {
  [AgencyNoticeType.CRITICAL]: "exclamation-triangle",
  [AgencyNoticeType.INFO]: "info-outline",
  [AgencyNoticeType.SUCCESS]: "check-circle",
  [AgencyNoticeType.WARNING]: "exclamation-triangle",
};
